import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/semantic-platform/data-governance/impact/")({
  validateSearch: (search: Record<string, unknown>): { ns?: string } => {
    return typeof search.ns === "string" && search.ns ? { ns: search.ns } : {};
  },
  component: LegacyImpactRedirect,
});

/** 影响分析已并入分析中心（header 子 Tab：使用/影响/质量） */
function LegacyImpactRedirect() {
  const { ns } = Route.useSearch();
  return <Navigate to="/semantic-platform/data-governance/analysis" search={{ tab: "impact", ...(ns ? { ns } : {}) }} replace />;
}
